import type { RouteLocationNormalized, NavigationGuardNext } from "vue-router";

export default async function guardLogin({ from, next, authStore }: { from: RouteLocationNormalized; next: NavigationGuardNext; authStore: any }) {
  try {
    const user = authStore.user;

    // If the user is logged in, proceed to the form page instead of the login page.
    if (user) {
      return next(from.fullPath);
    }
  } catch (error) {
    document.location.href = "/login";
  }

  return next();
}
